import { render, staticRenderFns } from "./AddCompanyGroupModal.vue?vue&type=template&id=635f0987&scoped=true&"
import script from "./AddCompanyGroupModal.vue?vue&type=script&lang=js&"
export * from "./AddCompanyGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./AddCompanyGroupModal.vue?vue&type=style&index=0&id=635f0987&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635f0987",
  null
  
)

export default component.exports